import { useAccount } from "@qw/auth";
import { useParams } from "react-router";

import { useInboxQueryStates } from "@/providers/inbox-query-states-provider";

export interface ChatScope {
  conversationId: string | null;
  /** localStorage key the chat's tool filter lives under. */
  toolFilterStorageKey: string;
}

/**
 * What the foreground chat is about on the current route: a conversation, an
 * insured, or the broker's book. Shared by the chat column and the nav's Alby
 * menu, which both have to name the same tool-filter key — they sit in sibling
 * trees, so nothing but agreeing on this derivation keeps them pointed at one
 * chat.
 */
export const useChatScope = (): ChatScope => {
  const { user } = useAccount();
  const { conversationId } = useInboxQueryStates();
  const { insuredId } = useParams();

  return {
    conversationId: conversationId ?? null,
    toolFilterStorageKey: conversationId || insuredId || `book-chat-${user.id}`,
  };
};
